import React from 'react';

function CampusContact() {
  return (
    <section className="contact-section" id="contact">
      <div className="container">
        <div className="section-header text-center">
          <div className="section-tag">
            <span className="badge-pill badge-pill-amber">Admissions &amp; Office</span>
          </div>
          <h2 className="section-title">Connect with Durbhasi Gurukulam</h2>
          <p className="section-desc">
            Have questions about cohort prerequisites, offline classroom batches, or admissions? Contact our team directly.
          </p>
        </div>

        <div className="contact-cards-grid">
          {/* Card 1: Address */}
          <div className="contact-card-box">
            <div className="contact-icon-large">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>
            </div>
            <h3 className="contact-card-title">Campus &amp; Office</h3>
            <p className="contact-card-desc">
              P.No. 18, Radha Vihar, Manchwa, Jaipur, Rajasthan 303706, India
            </p>
            <span className="contact-card-action" style={{ textDecoration: 'none', color: 'var(--text-muted)' }}>
              Open Monday – Saturday (10 AM - 6 PM)
            </span>
          </div>

          {/* Card 2: Phone & WhatsApp */}
          <div className="contact-card-box">
            <div className="contact-icon-large">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
              </svg>
            </div>
            <h3 className="contact-card-title">Direct Helpline &amp; WhatsApp</h3>
            <p className="contact-card-desc">
              Reach our admissions advisors directly for track selection, syllabus, and fee concession queries.
            </p>
            <a href="tel:+917852034945" className="contact-card-action">+91 7852034945</a>
          </div>

          {/* Card 3: Email */}
          <div className="contact-card-box">
            <div className="contact-icon-large">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                <polyline points="22,6 12,13 2,6"></polyline>
              </svg>
            </div>
            <h3 className="contact-card-title">Admissions Email</h3>
            <p className="contact-card-desc">
              Send syllabus inquiries, background portfolios, or corporate cohort sponsorship requests.
            </p>
            <a href="mailto:info@durbhasigurukulam.com" className="contact-card-action">info@durbhasigurukulam.com</a>
          </div>
        </div>

        <div className="contact-campus-notice" style={{ marginTop: '32px', padding: '16px 20px', background: 'var(--bg-slate-50)', border: '1px solid var(--border-light)', borderRadius: 'var(--radius-md)', fontSize: '0.88rem', color: 'var(--text-body)', textAlign: 'center' }}>
          <strong>Visiting the Jaipur Campus:</strong> In-person counseling, offline classroom batch enrollment, and architecture whiteboard discussions are hosted Monday through Saturday from 10:00 AM to 6:00 PM IST by prior appointment.
        </div>
      </div>
    </section>
  );
}

export default CampusContact;
